import { WorldReady } from '@paypalcorp/worldready'
import { getWorldReadyRules } from 'intl'

// WorldReady should be loaded first before creating any instance of it
WorldReady.load(getWorldReadyRules())
